(function() { module.exports = this["wp"]["components"]; }());


//////////////////
// WEBPACK FOOTER
// external {"this":["wp","components"]}
// module id = 4
// module chunks = 0